import React from "react";

export default function KairoBenchLanding() {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8 sm:px-12 lg:px-24">
      <header className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">The Bench</h1>
        {/* <p className="text-lg text-gray-600 max-w-xl mx-auto">
          The smart standing bench with robotic arms — folding clothes, prepping meals,
          and making daily life smoother. Work smarter, live easier.
        </p> */}
      
        <div className="mt-8">
            <img src="/concept2.jpg" alt="KairoBench folding cloth demo" className="mx-auto max-w-full h-auto rounded-lg shadow-md" />
        </div>
        
        
      </header>
    </div>
  );
}
